<template>

<footer class="authfooter footer">
  <div class="content has-text-centered">
    <p>
          © 2020 <strong style="color: #7F63F4">Virtual Red</strong> - Todos os direitos reservados. 
    </p>
  </div>
</footer>

</template>

<script>
export default {
  data() {
    return {};
  },
  name: "internfooter"
};
</script>